// The Zaptude avatar registry — the ONE list of avatars the product offers.
//
//   id       persisted in users.avatar_id and validated by the server (playerProgressService.AVATAR_IDS).
//            PERMANENT and APPEND-ONLY: z-01…z-12 were the original geometric avatars and must keep resolving
//            for students who already chose one; z-13…z-21 are additions. Never renumber, reorder or remove.
//   name     display name
//   file     the supplied illustration (client/public/art/avatars/<file>.svg — originals in /avatar_svgs,
//            cleaned by scripts/prepare_svg_assets.js)
//   tone     colour behind the art. Most of the supplied avatars are full-bleed discs; a few were exported on a
//            transparent background, so they get a tinted disc to sit on.
//   group    for future filtering only (people / creatures / characters)
//   unlock   the Level at which the avatar becomes selectable (1 = open from the start). Mirrors
//            server/services/avatarUnlocks.js, which is what actually enforces it — a parity test guards drift.
const PUBLIC = process.env.PUBLIC_URL || '';

export const AVATARS = [
  { id: 'z-01', unlock: 5, name: 'Alien',      file: 'alien',          group: 'characters' },
  { id: 'z-02', unlock: 5, name: 'Astronaut',  file: 'astronaut',      group: 'characters' },
  { id: 'z-03', unlock: 1, name: 'Rookie',     file: 'boy_1',          group: 'people',     tone: 'var(--z-tint-indigo)' },
  { id: 'z-04', unlock: 1, name: 'Cat',        file: 'cat',            group: 'creatures' },
  { id: 'z-05', unlock: 1, name: 'Dragon',     file: 'dragon',         group: 'creatures' },
  { id: 'z-06', unlock: 3, name: 'Trailblazer', file: 'girl',          group: 'people' },
  { id: 'z-07', unlock: 4, name: 'Hacker',     file: 'hacker',         group: 'characters', tone: 'var(--z-tint-cyan)' },
  { id: 'z-08', unlock: 7, name: 'Knight',     file: 'knight',         group: 'characters', tone: 'var(--z-tint-gold)' },
  { id: 'z-09', unlock: 8, name: 'Captain',    file: 'man',            group: 'people' },
  { id: 'z-10', unlock: 3, name: 'Scholar',    file: 'man_1',          group: 'people' },
  { id: 'z-11', unlock: 6, name: 'Ninja',      file: 'ninja',          group: 'characters' },
  { id: 'z-12', unlock: 1, name: 'Panda',      file: 'panda_avatar',   group: 'creatures' },
  { id: 'z-13', unlock: 1, name: 'Penguin',    file: 'penguin',        group: 'creatures' },
  { id: 'z-14', unlock: 9, name: 'Executive',  file: 'profile',        group: 'people' },
  { id: 'z-15', unlock: 1, name: 'Rabbit',     file: 'rabbit',         group: 'creatures' },
  { id: 'z-16', unlock: 4, name: 'Robot',      file: 'robot',          group: 'characters' },
  { id: 'z-17', unlock: 2, name: 'Analyst',    file: 'user',           group: 'people' },
  { id: 'z-18', unlock: 2, name: 'Explorer',   file: 'woman_1',        group: 'people' },
  { id: 'z-19', unlock: 6, name: 'Strategist', file: 'woman_2',        group: 'people' },
  { id: 'z-20', unlock: 8, name: 'Mentor',     file: 'woman_3',        group: 'people' },
  { id: 'z-21', unlock: 1, name: 'Achiever',   file: 'woman_4',        group: 'people' },
];

export const AVATAR_IDS = AVATARS.map(a => a.id);
export const getAvatar = (id) => AVATARS.find(a => a.id === id) || null;
export const avatarSrc = (avatar) => `${PUBLIC}/art/avatars/${avatar.file}.svg`;

export const unlockLevel = (avatar) => (avatar && avatar.unlock) || 1;
export const isUnlocked = (avatar, level) => (Number(level) || 1) >= unlockLevel(avatar);
// basic / medium / advanced — for grouping the picker; open avatars are their own "Available now" group.
export const tierOf = (avatar) => { const u = unlockLevel(avatar); return u <= 1 ? 'open' : u <= 3 ? 'basic' : u <= 6 ? 'medium' : 'advanced'; };
